import { useTranslation } from '@/contexts/i18n-context';
import { ErrorLayout } from '@/components/error-layout';

export function NotFoundPage() {
  const { t } = useTranslation();

  return <ErrorLayout title={t('notFound.title')} description={t('notFound.description')} />;
}
